import { ethers } from 'ethers'

import { PublicKey } from '@solana/web3.js'

import { ChainId } from '@src/configs/chainInfo'
import { Address } from '@src/types/token'
import { isBitcoinAddress } from '@src/utils/address'

export const validateDestinationAddress = (address: Address | undefined, networkId: number): boolean => {
    if (!address) return false

    // Bitcoin address validation
    if (networkId === ChainId.Bitcoin) {
        return isBitcoinAddress(address)
    }

    // Solana address validation
    if (networkId === ChainId.Solana) {
        return validateSolAddress(address)
    }

    // Tron address validation
    if (networkId === ChainId.Tron) {
        const tronAddressRegex = /^T[1-9A-HJ-NP-Za-km-z]{33}$/
        return tronAddressRegex.test(address)
    }

    // EVM address validation
    return validateEvmAddress(address)
}

// Validate EVM address
export function validateEvmAddress(address: string) {
    return ethers.isAddress(address)
}

// Validate Solana address
export function validateSolAddress(address: string) {
    try {
        const pubkey = new PublicKey(address)
        const isSolana = PublicKey.isOnCurve(pubkey.toBuffer())
        return isSolana
    } catch (error) {
        return false
    }
}
